import axios from 'axios';
import Config from '../../misc/Config';

const COMPANY_API_URL = Config.GFU_API_URL + '/companies';
const SEMINAR_API_URL = Config.GFU_API_URL + '/seminars';
const TRAINER_API_URL = Config.GFU_API_URL + '/trainers';

const state = {
    companyRating: [],
    seminarRating: [],
    trainerRating: []
};

const getters = {
    companyRating: (state) => state.companyRating,
    seminarRating: (state) => state.seminarRating,
    trainerRating: (state) => state.trainerRating
};

const actions = {
    async fetchCompanyRating({ commit }, id) {
        const response = await axios.get(COMPANY_API_URL + '/' + id.split("_")[0] +'/top-reviews'); 
        commit('setCompanyRating', response.data);
    },
    async fetchSeminarRating({ commit }, id) {
        const response = await axios.get(SEMINAR_API_URL + '/' + id +'/top-reviews'); 
        commit('setSeminarRating', response.data);
    },
    async fetchTrainerRating({ commit }, id) {
        const response = await axios.get(TRAINER_API_URL + '/' + id +'/top-reviews');
        commit('setTrainerRating', response.data);
    },
};

const mutations = {
    setCompanyRating: (state, companyRating) => state.companyRating = companyRating,
    setSeminarRating: (state, seminarRating) => state.seminarRating = seminarRating,
    setTrainerRating: (state, trainerRating) => state.trainerRating = trainerRating,
};


export default {
    state,
    getters,
    actions,
    mutations,
}